import React, { useEffect, useState } from "react";
import { Settings } from "lucide-react";
import { toast } from "react-hot-toast";
import { permissionAPI } from "../../services/AdminPortal/permissionsAPI";
import EditEmployeeModal from "./EditEmployeeModal";
const ROLES = ["admin", "subAdmin", "credit-manager", "staff"];

const Permissions = () => {
  const [activeTab, setActiveTab] = useState("employees");
  const [employees, setEmployees] = useState([]);
  const [roleFilter, setRoleFilter] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // ================= FETCH EMPLOYEES =================
  const fetchEmployees = async () => {
    try {
      const res = await permissionAPI.getAllEmployees();

      // ✅ FIXED
      setEmployees(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch employees");
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);
  const confirmDelete = async () => {
    try {
      await permissionAPI.deleteEmployee(deleteId);
      toast.success("Employee deleted");
      fetchEmployees();
    } catch (err) {
      toast.error("Delete failed");
    } finally {
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };
  // ================= DELETE =================
  const handleDelete = async (id) => {
    try {
      await permissionAPI.deleteEmployee(id);
      toast.success("Employee deleted");
      fetchEmployees();
    } catch (err) {
      toast.error("Delete failed");
    }
  };

  // ================= EDIT =================
  const handleEdit = (emp) => {
    console.log("Edit employee:", emp);
    toast("Edit coming soon");
  };

  // ================= FILTER =================
  const filteredEmployees = roleFilter
    ? employees.filter((emp) => emp.role === roleFilter) // ✅ FIXED
    : employees;

  return (
    <div className="bg-[#131313] rounded-lg p-4 md:p-6 w-full text-white">
      {/* HEADER */}
      <div className="flex items-center gap-2 mb-4">
        <Settings size={20} className="text-[#FFCA20]" />
        <h2 className="text-lg font-bold">Role & Employee Management</h2>
      </div>

      {/* TABS */}
      <div className="flex gap-4 mb-6">
        {/* <button
          onClick={() => setActiveTab("roles")}
          className={`px-4 py-2 rounded ${
            activeTab === "roles" ? "bg-[#FFCA20] text-black" : "bg-[#222]"
          }`}
        >
          Role Permissions
        </button> */}

        <button
          onClick={() => setActiveTab("employees")}
          className={`px-4 py-2 rounded ${
            activeTab === "employees" ? "bg-[#FFCA20] text-black" : "bg-[#222]"
          }`}
        >
          Employees
        </button>
      </div>

      {/* ================= ROLE TAB ================= */}
      {/* {activeTab === "roles" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {ROLES.map((role) => (
            <div
              key={role}
              className="p-4 border border-[#333] rounded hover:border-yellow-400"
            >
              <h3 className="font-bold text-lg capitalize">{role}</h3>
              <p className="text-sm text-gray-400 mt-2">
                {role === "admin" && "Full system access"}
                {role === "subAdmin" && "Manage users & operations"}
                {role === "credit-manager" && "Loan approvals & credit ops"}
                {role === "staff" && "Basic loan operations"}
              </p>
            </div>
          ))}
        </div>
      )} */}

      {/* ================= EMPLOYEE TAB ================= */}
      {activeTab === "employees" && (
        <div>
          {/* FILTER */}
          <div className="mb-4">
            <select
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
              className="p-2 bg-black border border-[#333] rounded"
            >
              <option value="">All Roles</option>
              {ROLES.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>

          {/* TABLE */}
          <div className="overflow-x-auto">
            <table className="w-full border border-[#333]">
              <thead className="bg-[#222]">
                <tr>
                  <th className="p-3 text-left">Name</th>
                  <th className="p-3 text-left">Email</th>
                  <th className="p-3 text-left">Role</th>
                  <th className="p-3 text-left">Status</th>
                  <th className="p-3 text-left">Actions</th>
                </tr>
              </thead>

              <tbody>
                {filteredEmployees.length > 0 ? (
                  filteredEmployees.map((emp) => (
                    <tr key={emp._id} className="border-t border-[#333]">
                      <td className="p-3">{emp.name}</td>
                      <td className="p-3">{emp.email}</td>

                      {/* ✅ FIXED ROLE */}
                      <td className="p-3 capitalize">{emp.role}</td>

                      {/* ✅ BONUS STATUS */}
                      <td className="p-3">
                        <span
                          className={`px-2 py-1 rounded text-xs ${
                            emp.status === "active"
                              ? "bg-green-600"
                              : "bg-red-600"
                          }`}
                        >
                          {emp.status}
                        </span>
                      </td>

                      <td className="p-3 flex gap-3">
                        <button
                          onClick={() => {
                            setSelectedEmployee(emp);
                            setOpenModal(true);
                          }}
                          className="text-yellow-400 hover:underline"
                        >
                          Edit
                        </button>

                        <button
                          onClick={() => {
                            setDeleteId(emp._id);
                            setShowDeleteModal(true);
                          }}
                          className="text-red-500 hover:underline"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center p-4">
                      No employees found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <EditEmployeeModal
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            employee={selectedEmployee}
            onUpdated={fetchEmployees}
          />
          {showDeleteModal && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
              <div className="bg-[#131313] p-6 rounded-lg w-full max-w-sm text-center">
                <h3 className="text-lg font-semibold mb-3">Are you sure?</h3>

                <p className="text-gray-400 mb-5 text-sm">
                  Do you really want to delete this employee? This action cannot
                  be undone.
                </p>

                <div className="flex justify-center gap-4">
                  {/* CANCEL */}
                  <button
                    onClick={() => setShowDeleteModal(false)}
                    className="px-4 py-2 border border-gray-400 rounded hover:bg-gray-700"
                  >
                    Cancel
                  </button>

                  {/* CONFIRM */}
                  <button
                    onClick={confirmDelete}
                    className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Permissions;
